import { render, staticRenderFns } from "./chatView.vue?vue&type=template&id=fb52ba84&scoped=true"
import script from "./chatView.vue?vue&type=script&lang=js"
export * from "./chatView.vue?vue&type=script&lang=js"
import style0 from "./chatView.vue?vue&type=style&index=0&id=fb52ba84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb52ba84",
  null
  
)

export default component.exports